import { Component, ImageViewer } from "../..";
import { ImageViewerSessionStorage } from "./ImageViewerSessionStorage";
import { ImageViewerValues } from "./ImageViewerValues";
import { OpenButtons, OpenButtonsProps } from "../openButtons/OpenButtons";
import { OpenType } from "../openButtons/OpenType";

/**
 * This class provides the 'open in new tab/window' buttons to be used in conjunction with the ImageViewer.
 */
export class ImageViewerOpenButtons extends OpenButtons {
    private imageViewerValues: ImageViewerValues;
    private imageViewerValuesProvider: () => ImageViewerValues|Promise<ImageViewerValues>;
    
    constructor(parentComponent: Component,
        imageViewerValuesProvider: () => ImageViewerValues|Promise<ImageViewerValues>,
        overrideProps?: Partial<OpenButtonsProps>) {
        super({
            allowedTypes: [OpenType.SAME_TAB, OpenType.NEW_TAB_WITH_SWITCH, OpenType.NEW_WINDOW],
            defaultType: OpenType.NEW_WINDOW,
            itemDescr: "image",
            layoutPath: "components/page/imageViewer/ImageViewer",
            localSettingsKey: "imageViewer.openButtons",
            parentComponent,
            ...overrideProps
        });
        this.imageViewerValuesProvider = imageViewerValuesProvider;
    }

    protected override async openInSameTab(_url: string): Promise<void> {
        // Open the image modally in the ImageViewer
        ImageViewer.viewImage(this.imageViewerValues);
    }

    public async open(type: OpenType = this.defaultTypeForUser): Promise<void> {
        this.defaultButton.busy = true;
        this.imageViewerValues = await this.imageViewerValuesProvider();

        // If the image cannot be previewed, call viewOrDownload so that it is downloaded.  The user will be notified by
        // that method via a snackbar.
        if (ImageViewer.eligibleToView(this.imageViewerValues.fileName) !== true) {
            ImageViewer.viewOrDownload(this.imageViewerValues);
            return;
        }

        // If the image is being opened in a new tab/window, first store the image values in the current tab's session
        // storage.  This will result in the image values being available in the new tab/window when it is opened.
        // The Image Viewer in the new tab/window will look in session storage for an image when it is opened without
        // an image being provided.
        if (type !== OpenType.SAME_TAB) {
            new ImageViewerSessionStorage().save(this.imageViewerValues);
        }
        super.open(type);
    }
}
